import HeaderNavigationBar from './HeaderNavigationBar.vue';

export default HeaderNavigationBar;
